<template>
  <transition name="message" appear>
    <div
      class="home-message"
      v-if="message._id ? message[$i18n.locale].title : false"
    >
      <span
        class="kcm close"
        :style="{ color: message.background }"
        @click="message = {}"
        >J</span
      >
      <div class="bg" :style="{ background: message.background }"></div>
      <main>
        <p>{{ message[$i18n.locale].title }}</p>
        <div v-html="message[$i18n.locale].content"></div>
      </main>
      <footer v-if="message.link">
        <a :href="message.link" target="_blank" class="link">
          <span class="text-light">{{ $t("learn-more") }}</span>
        </a>
      </footer>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      message: {},
      show: false,
    };
  },
  methods: {
    getMessages() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/message?latest=true`)
        .then((result) => {
          this.message = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.getMessages();
    }, 1000);
  },
};
</script>

<style lang="scss">
.home-message {
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  color: #fff;
  overflow: hidden;
  padding: 52px 26px 46px;
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.5s ease;
  width: 530px;
  z-index: 9;

  .bg {
    background: red;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0.9;
    position: absolute;
    top: 0;
    width: 100%;
  }

  > main {
    position: relative;
    z-index: 1;

    > p {
      font-size: 26px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 30px;
      text-align: center;
    }

    > div {
      text-align: center;

      p {
        color: #fff;
        font-size: 18px;
      }
      a {
        color: #fff;
        text-decoration: underline;
      }
    }
  }

  > footer {
    margin-top: 30px;
    text-align: center;
    .link {
      &::before {
        background-color: #fff;
      }

      &:hover {
        span {
          color: $mainColor;
        }
      }
    }
  }

  .close {
    align-items: center;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
    display: inline-flex;
    font-size: 12px;
    height: 30px;
    justify-content: center;
    line-height: 12px;
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    z-index: 1;
    @include transition(all 0.3s);

    &:hover {
      opacity: 0.9;
    }
  }
}

.message-enter-active,
.message-leave-active {
  @include transition(all 0.5s);
}

.message-enter,
.message-leave-to {
  @include transform(translateY(-50%) translateX(100%));
}

@media screen and (max-width: 600px) {
  .home-message {
    width: 90vw;
  }
}
</style>
